// extracted by mini-css-extract-plugin
export default {"backdrop":"CRMModalLayout_backdrop__94K2R","modal":"CRMModalLayout_modal__Lk9f5","title":"CRMModalLayout_title__sGjXG","description":"CRMModalLayout_description__Sx65c"};